import axiosInstance from '../api/axios';

export type DevelopmentTelegramChat = {
  title: string;
  invite_url: string | null;
};

export type DevelopmentBaselineTrader = {
  actual_in_admin: boolean;
  chat_added_in_admin: boolean;
  trader_chat_url: string | null;
  team_lead: string | null;
  team_lead_chat_url: string | null;
  rate_in: string | null;
  rate_out: string | null;
  referral_percent: string | null;
  circle: string | null;
  safe_deposit: string | null;
};

export type DevelopmentCurrentTrader = {
  found_in_admin: boolean;
  status: 'ACTIVE' | 'INACTIVE' | 'ARCHIVED' | 'NOT_FOUND';
  trader_chats: DevelopmentTelegramChat[];
  group_name: string | null;
  team_lead: string | null;
  team_lead_chats: DevelopmentTelegramChat[];
  rate_in: string | null;
  rate_out: string | null;
  referral_percent: string | null;
  circle: string | null;
  safe_deposit: string | null;
};

export type DevelopmentTraderDirectoryItem = {
  id: string | null;
  name: string;
  username: string | null;
  telegram_nickname: string | null;
  baseline: DevelopmentBaselineTrader | null;
  current: DevelopmentCurrentTrader;
};

export type DevelopmentTraderDirectoryResponse = {
  items: DevelopmentTraderDirectoryItem[];
  total: number;
  page: number;
  pages: number;
};

export const developmentService = {
  getTraderDirectory: async (params: {
    search?: string;
    status?: 'all' | 'active' | 'inactive' | 'archived' | 'not_found';
    page?: number;
  } = {}) => (
    await axiosInstance.get<DevelopmentTraderDirectoryResponse>('/development/traders', {
      params: { limit: 100, ...params },
    })
  ).data,
};
